import useGet from "../useGet";
import { CompanySummary } from "../useCompanies/useCompanies";
import { MoneyCorpPermissions } from "../usePermissions/usePermissions";

export type BranchSummary = {
  id: number;
  name: string;
  company?: CompanySummary;
};

const useCompanyBranches = (
  companyId: string | undefined,
  permissions: MoneyCorpPermissions,
  dependencies: any[]
) => {
  const hasPermission = permissions.readBranches || permissions.admin;
  const { value, loading } = useGet(
    `/api/Companies/${companyId}/Branches?ts=` + new Date().getTime(),
    "Unable to read branches for company id: '" + companyId + "'",
    hasPermission ? null : [],
    [...dependencies, companyId, hasPermission],
    undefined,
    () => companyId != null && companyId !== "" && hasPermission
  );

  return {
    companyBranches: value as BranchSummary[],
    companyBranchesLoading: loading as boolean
  };
};

export default useCompanyBranches;
